import { createSlice } from "@reduxjs/toolkit";
import { removeBansOnLogout } from "../bans";

const initialUser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;

const slice = createSlice({
  name: "user",
  initialState: {
    user: initialUser,
  },
  reducers: {
    setUser: (state, action) => {
      // Set user in current state without updating localStorage
      state.user = action.payload;
    },
    setUserAndUpdateLocalStorage: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    reloadUser: (state, action) => {
      state.user = undefined;
      state.user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
    },
    loginSuccess: (state, { payload }) => {
      const { data } = payload;
      state.user = data;
      localStorage.setItem("user", JSON.stringify(data));
    },
    logoutSuccess: (state) => {
      state.user = null;
      localStorage.removeItem("user");
    },
    changeDataSuccess: (state, action) => {
      const { payload } = action;
      state.user = {
        ...state.user,
        tipo_state: payload.tipo_state,
        login_data: {
          ...state.user.login_data,
          e_mail: payload.e_mail,
          telefono: payload.telefono,
          citta: payload.citta,
          indirizzo: payload.indirizzo,
          cap: payload.zipcode,
          iban: payload.iban,
        },
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    changePrivacySuccess: (state, action) => {
      const { payload } = action;
      state.user = {
        ...state.user,
        flag_marketing: payload.flag_marketing,
        flag_profilazione: payload.flag_profilazione,
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    loadBalanceDetailsSuccess: (state, action) => {
      const { payload } = action;
      state.user = {
        ...state.user,
        saldo_sport: state.user.saldo_sport,
        balance_details: { ...payload },
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    updateBalanceSuccess: (state, action) => {
      const { payload } = action;
      const saldoSport = state.user.saldo_sport;
      const newSaldo = payload ? saldoSport + payload * 100 : saldoSport;

      state.user = {
        ...state.user,
        saldo_sport: newSaldo,
        login_data: {
          ...state.user.login_data,
          num_versamento: state.user.login_data.num_versamento + 1,
        },
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    onCashoutSuccess: (state, action) => {
      const { payload } = action;
      const saldoSport = state.user.saldo_sport;
      const newSaldo = payload ? saldoSport + payload : saldoSport;
      state.user = {
        ...state.user,
        saldo_sport: newSaldo,
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    setWinningLimitSuccess: (state, action) => {
      const { payload } = action;
      const { value, response, error } = payload;
      state.user = {
        ...state.user,
        winning_limit: { value, response, error },
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    loadIncomingInboxSuccess: (state, action) => {
      const { payload } = action;
      state.user = {
        ...state.user,
        new_inbox: payload,
      };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
  },
});

export const updateBalance = (data) => async (dispatch) => {
  try {
    data && dispatch(updateBalanceSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const onCashout = (data) => async (dispatch) => {
  try {
    data && dispatch(onCashoutSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const login = (data) => async (dispatch) => {
  try {
    data ? dispatch(loginSuccess(data)) : dispatch(logoutSuccess());
  } catch (e) {
    return console.error(e.message);
  }
};

export const logout = () => async (dispatch) => {
  try {
    removeBansOnLogout(dispatch);
    return dispatch(logoutSuccess());
  } catch (e) {
    return console.error(e.message);
  }
};

export const deleteUser = () => async (dispatch) => {
  try {
    return dispatch(logoutSuccess());
  } catch (e) {
    return console.error(e.message);
  }
};

export const changeDataStore = (data) => async (dispatch) => {
  try {
    dispatch(changeDataSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const changePrivacyStore = (data) => async (dispatch) => {
  try {
    dispatch(changePrivacySuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const loadBalanceDetails = (data) => async (dispatch) => {
  try {
    dispatch(loadBalanceDetailsSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const setWinLimit = (data) => async (dispatch) => {
  try {
    dispatch(setWinningLimitSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const loadIncomingInbox = (data) => async (dispatch) => {
  try {
    dispatch(loadIncomingInboxSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

const { actions, reducer } = slice;

export const {
  loginSuccess,
  logoutSuccess,
  updateBalanceSuccess,
  changeDataSuccess,
  changePrivacySuccess,
  loadBalanceDetailsSuccess,
  loadWinningLimitSuccess,
  setWinningLimitSuccess,
  loadIncomingInboxSuccess,
  onCashoutSuccess,
  reloadUser,
  setUser,
  setUserAndUpdateLocalStorage,
} = actions;

export default reducer;
